var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"nav nav-mobile-menu"},[_c('li',[_c('a',{staticClass:"dropdown-toggle",attrs:{"data-toggle":"dropdown"},on:{"click":_vm.logout}},[_c('i',{staticClass:"material-icons"},[_vm._v("logout")]),_c('p',[_vm._v("Logout")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }